module.exports = __webpack_public_path__ + "img/user_yes_real.47819c1d.png";